import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import avatar from '@material-ui/core/colors/grey';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  title: {
    width: '130px',
  },
  avatar: {
    color: '#fff',
    backgroundColor: avatar[500],
  },
  caption: {
    marginLeft: theme.spacing.unit*2,
  },
});

const JobSummaryItem = ({ classes, title, caption, numItems }) => {
  return(
    <div className={classes.root}>
      <Typography
        className={classes.title}
        variant="subheading">
        {title}
      </Typography>
      <Avatar className={classes.avatar}>{numItems}</Avatar>
      <Typography
        className={classes.caption}
        variant="caption">
        {caption}
      </Typography>
    </div>
  );
};


export default withStyles(styles)(JobSummaryItem);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobSummaryItem.jsx